module.exports = __webpack_public_path__ + "static/media/starDisk.35e6de41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/starDisk.png
// module id = 2215
// module chunks = 0